<template>
  <div id="taskbar">
    <div>
      <div class="taskbar-wrapper">
        <div class="item first-item" v-on:click="orderTypeList = !orderTypeList">
          <i class="fas fa-list-ol"></i>
          Order by
          <div v-if="orderTypeList" class="order-dropdown">
            <div
              v-for="orderType in orderTypes"
              :key="orderType.index"
              class="order-dropdown-item"
              @click="setOrderType(orderType)"
            >{{ orderType }}</div>
          </div>
        </div>
        <div class="item" v-on:click="modifySearch()">
          <i class="fas fa-search"></i>
          Modify search
        </div>
        <div class="selected-flights">
          <div
            class="selected-outbound"
            :class="{'flat-padding': !isEmpty(selectedFlights.outbound)}"
          >
            <b-tooltip
              v-if="isEmpty(selectedFlights.outbound)"
              class="default-tooltip"
              :label="flags.isDomesticReturn ? 
                        'Please select an outbound flight from the list on the left. Outbound and return flights are booked separately in order to ensure the best deals.' :
                        'Please select your flight from the list. Make sure to check all flight details carefully.'"
              position="is-bottom"
              multilined
            >{{!flags.isDomesticReturn ? 'Select Flight' : 'Select outbound'}}</b-tooltip>
            <div class="flight-overview" v-else>
              <img
                class="taskbar-image"
                :src="getPathToLogo(selectedFlights.outbound.odoList[0].segments[0].airlineCode)"
                alt="outbound airline"
              />
              <b>R{{Math.ceil(selectedFlights.outbound.amount)}}</b>
              <br />
              <span class="details-blurb">
                <b>
                  {{selectedFlights.outbound.odoList[0].segments[0].airlineCode}}
                  {{selectedFlights.outbound.odoList[0].segments[0].flightNumber}}
                </b>
                Departing at
                <b
                  class="no-left-margin"
                >{{selectedFlights.outbound.absoluteDepartureTime}}</b>
              </span>
            </div>
          </div>
          <b-icon v-if="flags.isDomesticReturn" type="is-grey" icon="swap-horizontal" />
          <div
            v-if="flags.isDomesticReturn"
            class="selected-return"
            :class="{'flat-padding': !isEmpty(selectedFlights.return)}"
          >
            <b-tooltip
              v-if="isEmpty(selectedFlights.return)"
              class="default-tooltip"
              position="is-bottom"
              label="Please select a return flight from the list on the right. Outbound and return flights are booked separately in order to ensure the best deals."
              multilined
            >Select return</b-tooltip>
            <div class="flight-overview" v-else>
              <img
                class="taskbar-image"
                :src="getPathToLogo(selectedFlights.return.odoList[0].segments[0].airlineCode)"
                alt="return airline"
              />
              <b>R{{Math.ceil(selectedFlights.return.amount)}}</b>
              <br />
              <span class="details-blurb">
                <b>
                  {{selectedFlights.return.odoList[0].segments[0].airlineCode}}
                  {{selectedFlights.return.odoList[0].segments[0].flightNumber}}
                </b>
                Departing at
                <b
                  class="no-left-margin"
                >{{selectedFlights.return.absoluteDepartureTime}}</b>
              </span>
            </div>
          </div>
        </div>
        <b-tooltip
          class="pushed-right"
          type="is-secondary"
          :label="determineLabel()"
          :active="true"
          position="is-bottom"
        >
          <b-button
            type="is-primary"
            @click="toggleReviewModal()"
            :disabled="!flags.allSelected || invalidSelection ? true : null"
          >Continue</b-button>
        </b-tooltip>
      </div>
      <b-message
        v-if="invalidSelection"
        type="is-danger"
        style="width: 100%; margin-top: 0.75em;"
      >For same day flight return cannot be before arrival!</b-message>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "taskbar",
  data: function() {
    return {
      orderTypeList: false,
      orderTypes: ["Price", "Time"],
      selectedOrder: "Price",
      isModifySearch: false
    };
  },
  computed: {
    ...mapState(["flags", "selectedFlights"]),
    invalidSelection() {
      if (
        this.flags.allSelected &&
        moment(
          this.selectedFlights.outbound.formattedDepartureDate,
          "dddd, MMMM Do YYYY"
        ).isSame(
          moment(
            this.selectedFlights.return.formattedDepartureDate,
            "dddd, MMMM Do YYYY"
          )
        )
      ) {
        if (
          moment(
            this.selectedFlights.return.absoluteDepartureTime,
            "HH:mm"
          ).isBefore(
            moment(this.selectedFlights.outbound.absoluteArrivalTime, "HH:mm")
          )
        ) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    determineLabel() {
      return !this.flags.allSelected
        ? `Select flights!`
        : `Total Price: 
            R${Math.ceil(
              this.selectedFlights.outbound.amount +
                (this.isEmpty(this.selectedFlights.return)
                  ? 0
                  : this.selectedFlights.return.amount)
            )}`;
    },
    getPathToLogo(marketingCode) {
      try {
        return require(`@/assets/images/logos/${marketingCode}.png`);
      } catch (error) {
        return require(`@/assets/images/logos/00.png`);
      }
    },
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    setOrderType(orderType) {
      this.selectedOrder = orderType;
      this.$store.commit("orderResults", this.selectedOrder);
    },
    modifySearch() {
      this.$parent.isModifySearch = true;
    },
    toggleReviewModal() {
      this.$store.commit("toggleFlightReview");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.flight-overview {
  display: flex;
  align-items: center;
  max-width: 170px;
  flex-wrap: wrap;
  justify-content: center;
  padding: 4px;
}

.details-blurb {
  margin-left: 0 !important;
  font-size: 0.7em;
}

.taskbar-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.no-left-margin {
  margin-left: 0 !important;
}

#taskbar {
  background: $light;
  padding: 1em;
  border-radius: 8px;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
  width: 100%;
  min-height: 50px;
}

.heading {
  background: $gradient-color;
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  text-align: center;
  padding: 0.75em;
}

.item {
  background: $light;
  cursor: pointer;
  padding: 0.3em;
  text-align: center;
  border-radius: 8px;
}

.first-item {
  margin-right: 0.75em;
}

.flat-padding {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.order-dropdown {
  position: absolute;
  width: 82px;
  margin-top: 8px;
  z-index: 102;
  margin-left: -6px !important;
  border: solid 1px #919191;
  border-radius: 3px;
  background: white;
  * + * {
    border-top: 1px dashed $primary-dark;
  }
  .order-dropdown-item {
    padding: 0.6em 0.3em;
    margin: 0;
    cursor: pointer;
  }
  .order-dropdown-item:hover {
    background: $grey;
  }
}

.pushed-right {
  margin-left: auto;
}

.selected-flights {
  display: flex;
  margin: auto;
  align-items: center;
  * + * {
    margin-left: 1em;
  }
}

.default-tooltip {
  display: flex;
  align-items: center;
  * + * {
    margin-left: 0.75em;
  }
}

.selected-outbound {
  padding: 0.4em;
  border: 1px dashed;
  border-radius: 8px;
  color: darken($grey, 10%);
}

.selected-return {
  padding: 0.4em;
  border: 1px dashed;
  border-radius: 8px;
  color: darken($grey, 10%);
}

.taskbar-image {
  max-height: 30px;
  max-width: 80px;
}
</style>